import React from "react";
import { Text, Flex } from "@fluentui/react-northstar";
import styles from "./cardFooterItem.module.scss";
import { SizeValue } from "@fluentui/react-northstar/dist/es/utils/commonPropInterfaces";

interface CardFooterItemProps {
    content?: string;
    children: React.ReactNode;
    textSize: SizeValue;
}

const CardFooterItem: React.FC<CardFooterItemProps> = (props: CardFooterItemProps) => {
    return (
        <Flex>
            {props.children}
            <Text className={styles.footerTextWithIcon} color="grey" size={props.textSize}>
                {props.content}
            </Text>
        </Flex>
    );
};

export default CardFooterItem;
